import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { BaseService } from 'src/app/services/common/base.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { first } from 'rxjs';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-je-survey-action-info',
  templateUrl: './je-survey-action-info.component.html',
  styleUrls: ['./je-survey-action-info.component.scss'],
  providers: [DatePipe]
})
export class JeSurveyActionInfoComponent implements OnInit {
  exportMenu: MenuItem[];

  public tableData: any = [];
  public tableHeaderName = 'Applications For Approval';

  public subscriptions: any = [];
  public subjectSub: any;
  public loading: boolean = false;
  public userId: any;
  public openReAssignDialog: boolean = false;
  public reAssignAppId: any;
  public reassignDate: any;
  public nextDate: Date;

  constructor(
    private messageService: MessageService,
    private cryptoJsService: CryptoJsService,
    private ipService: IpAddressService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private vendorService: VendorDashboardService,
    private deptDashBoardService: DepartmentDashboardService,
    private confirmationService: ConfirmationService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    this.nextDate = new Date();
    this.nextDate.setDate(this.nextDate.getDate() + 1);
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    // this.vendorRegId = JSON.stringify(token?.officeCode);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.exportMenu = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.tableData, `MI_${this.tableHeaderName}`);
        },
      }
    ];

    this.loadData();
  }


  loadData() {
    this.loading = true;
    let sub = this.deptDashBoardService
      .getAppIDAssignmentPlan(this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          if (data?.length > 0) {
            this.tableData = data;
          } else {
            this.tableData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }
        },
        error: (err) => {
          this.loading = false;
          this.tableData = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'APP Id': d.APP_ID,
          'Status': d.FarmerStatus,
          'Farmer Name': d.farmerName,
          'App Type': d.Applicant_type,
          'Constituency': d.Constituency,
          'District': d?.District,
          'Block': d?.Block,
          'Village': d?.Village,
          'Scheme': d.Scheme,
          'KYC Status': d.KYC_Status
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  rowBackgroundColor(row) {
    if (row.FarmerStatus == 'A') {
      //light green
      return '#99e699'
    }
    else if (row.FarmerStatus == 'P') {
      // light yellow
      return '#ffffc5'
    }
    else if (row.FarmerStatus == 'R') {
      //red
      return '#ff8080';
    }
    else if (row.FarmerStatus == 'RP') {
      //orange
      return '#ffc966';
    }
    else return '#ffffff';
  }

  onClickAssign(val) {
    this.confirmationService.confirm({
      header: 'Confirmation',
      message: `Are you sure you want to assign the survey for App Id: ${val?.App_ID}`,
      acceptIcon: 'pi pi-check mr-2',
      rejectIcon: 'pi pi-times mr-2',
      rejectButtonStyleClass: 'p-button-sm',
      acceptButtonStyleClass: 'p-button-outlined p-button-sm',
      accept: () => {
        this.onAssignPlan(val?.App_ID);
      },
      reject: () => {
          this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
      }
  });
  }

  onClickReAssign(val) {
    this.reAssignAppId = val?.App_ID
    this.openReAssignDialog = true;

  }

  onAssignPlan(appId) {
    let reqBody = {
      app_ID: appId,
    }
    this.loader.start();
    let sub = this.deptDashBoardService
      .jeAssignSurveyPlan(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });          
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }
  
  onConfirmReAssign(){
    this.onReAssignPlan(this.reAssignAppId, this.datePipe.transform(new Date(this.reassignDate), 'MM-dd-yyyy'))
  }

  onReAssignPlan(appId, newDate) {
    let reqBody = {
      "app_ID": appId,
      "assignReassignDate": newDate
    }
    this.loader.start();
    let sub = this.deptDashBoardService
      .reAssignSurveyPlan(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          let resp = data[0]?.Column1;
          if (resp.startsWith('Records successfully')) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: resp,
            });        
            this.loadData();  
            this.onCloseReAssignDialog();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: resp,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onCloseReAssignDialog(){
    this.openReAssignDialog = false;
    this.reassignDate = null;
  }

}

